<!--
 * @Date: 2022-09-02 10:20:56
 * @LastEditors: xiao
 * @LastEditTime: 2022-09-02 11:01:50
 * @FilePath: \gongzhaotiku\src\components\nav.vue
-->
<template >
  <div class="nav">
    <el-carousel height="370px">
      <el-carousel-item class="imgs" v-for="(item, index) in imgs" :key="index">
        <img @click="ref(item.url)" :src="item.image" :alt="item.name">
      </el-carousel-item>
    </el-carousel>
    <div class="nav-r">
      <img class="nav-rimg" @click="her(item.url)" v-show="index <= 2" v-for="(item, index) in  imge" :key="index"
        :src="item.image" :alt="item.name">
    </div>
  </div>
</template>
<script>
import EventBus from '../eventBus/eventBus'
export default {

  data() {
    return {
      imgs: [],
      imge: []
    }
  },
  methods: {
    async getPostes() {
      const data = await this.$api.getPoster({ city_id: localStorage.getItem('cityId') == null ? localStorage.getItem('ip').slice(0, 2) * 10000 : localStorage.getItem('cityId') })
      this.imgs = data?.data?.banner
      this.imge = data?.data?.poster
      //console.log(data.data.banner)
      EventBus.$emit('imgs', this.imgs)
    },
    // // 跳转轮播图广告地址
    ref(url) {
      //console.log(url)
      window.open(url)
    }
    // 跳转轮播图右侧图片广告地址
    , her(url) {
      window.open(url)
    }
  },
  created() {
    this.getPostes()
  }
}
</script>

<style lang='scss'  scoped>
.nav-r {
  width: 300px;
  height: 370px;
}

.nav-rimg {
  width: 300px;
  height: 110px;
  border-radius: 6px;
  margin: 0 0 20px 20px;
}

.nav {
  height: 370px;
  display: flex;
  margin-bottom: 30px;
  cursor: pointer;
}

.imgs {
  height: 370px !important;
  width: 100% !important;
  ;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 370px;
  width: 880px;
  margin: 0;
}

.el-carousel__item {
  width: 880px !important;
}

.el-carousel__indicators {
  position: absolute !important;
}

.el-carousel--horizontal {
  width: 880px !important;
  height: 370px !important;
  position: relative !important;
}

.el-carousel__item {
  width: 880px !important;

}

.el-carousel__indicators {
  position: absolute;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.el-carousel--horizontal img {
  width: 100%;
  height: 370px;
}
</style>